import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const mapping = {
  AR: 'Arabic',
  ZH: 'TraditionalChinese',
  DA: 'Danish',
  NL: 'Dutch',
  EN: 'English',
  FI: 'Finnish',
  FR: 'French',
  DE: 'German',
  IT: 'Italian',
  NO: 'Norwegian',
  PT: 'Portuguese',
  ES: 'Spanish',
  SV: 'Swedish',
  'ZH-HANS': 'SimplifiedChinese',
  EL: 'Greek',
  PL: 'Polish',
  BG: 'Bulgarian',
  HR: 'Croatian',
  CS: 'Czech',
  ET: 'Estonian',
  HU: 'Hungarian',
  LV: 'Latvian',
  LT: 'Lithuanian',
  MT: 'Maltese',
  RO: 'Romanian',
  SK: 'Slovak',
  SL: 'Slovenian',
  TR: 'Turkish',
  SR: 'Serbian',
  BS: 'Bosnian',
  SQ: 'Albanian',
  MK: 'Macedonian',
  IS: 'Icelandic',
  JA: 'Japanese',
  KO: 'Korean',
  RU: 'Russian',
  IW: 'Hebrew',
  HI: 'Hindi',
  MS: 'Malay',
  TH: 'Thai',
  IN: 'Indonesian',
  TL: 'Tagalog',
  VI: 'Vietnamese',
};

export function get() {
  let language = _.result(config.get('CurrentUser'), 'Language');

  language = language ? language.toUpperCase() : 'EN';
  return mapping[language] || 'English';
}
